import { get } from 'common';

const POETRY_ROUTE = `${process.env.REACT_APP_API_CONFIG}poetry`;
const POETRY_PAGE_ROUTE = `${process.env.REACT_APP_API_CONFIG}poetry-page`;

export class PoetryService {
    private static instance: PoetryService;

    static getInstance(): PoetryService {
        if (!this.instance) {
            this.instance = new PoetryService();
        }

        return this.instance;
    }

    async findAll() {
        return await get(`${POETRY_ROUTE}/`);
    }

    async findOne(id: number) {
        return await get(`${POETRY_ROUTE}/${id}/`);
    }

    async findClubInfo() {
        return await get(`${POETRY_PAGE_ROUTE}/`);
    }
}
